/**
 * CSV 읽기·쓰기 (RFC 4180, 엑셀에서 바로 열리게 UTF-8 BOM·CRLF). 관리자 공장 목록 내보내기와 공장 설비 양식이 같이 쓴다
 */
const cell = (v: string | number | null | undefined) => {
  const s = v === null || v === undefined ? '' : String(v)
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

export const csvLine = (cells: readonly (string | number | null | undefined)[]) =>
  cells.map(cell).join(',')

/** 줄들 → 파일 글자 (BOM 으로 시작, 줄마다 CRLF) */
export const csvDocument = (lines: readonly string[]) => `\uFEFF${lines.join('\r\n')}\r\n`

/** RFC 4180 꼴 CSV 를 줄·칸으로. 따옴표 안의 쉼표·줄바꿈을 지킨다 */
export function parseCsvRows(text: string): string[][] {
  const rows: string[][] = []
  let row: string[] = []
  let cell = ''
  let quoted = false
  const src = text.replace(/^\uFEFF/, '')
  for (let i = 0; i < src.length; i++) {
    const ch = src[i]!
    if (quoted) {
      if (ch === '"' && src[i + 1] === '"') {
        cell += '"'
        i++
      } else if (ch === '"') quoted = false
      else cell += ch
    } else if (ch === '"') quoted = true
    else if (ch === ',') {
      row.push(cell)
      cell = ''
    } else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && src[i + 1] === '\n') i++
      row.push(cell)
      rows.push(row)
      row = []
      cell = ''
    } else cell += ch
  }
  if (cell !== '' || row.length > 0) {
    row.push(cell)
    rows.push(row)
  }
  return rows
}
